export const turnstileErrorMessage = "Nie udało się potwierdzić, że nie jesteś robotem. Spróbuj ponownie.";

export const createTurnstileValidationError = () => ({
    appError: {
        status: 400,
        fieldErrors: {},
        nonFieldErrors: [turnstileErrorMessage]
    }
});

export const createTurnstileRtkError = () => ({
    status: 400,
    data: {
        non_field_errors: [turnstileErrorMessage]
    }
});
export const turnstileErrorMessage = "Nie udało się potwierdzić, że nie jesteś robotem. Spróbuj ponownie.";

export const createTurnstileValidationError = () => ({
    appError: {
        status: 400,
        fieldErrors: {},
        nonFieldErrors: [turnstileErrorMessage]
    }
});

export const createTurnstileRtkError = () => ({
    status: 400,
    data: {
        non_field_errors: [turnstileErrorMessage]
    }
});
